import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import { type FC } from "react";

export const ClaudeCodeLogo: FC<PropsWithClassName> = ({ className }) => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="12" cy="12" r="12" fill="#DA7756" />
            {/* Starburst rays radiating from center */}
            <g stroke="#F5EBE1" strokeWidth="1.5" strokeLinecap="round">
                <line x1="12" y1="12" x2="12" y2="4.5" />
                <line x1="12" y1="12" x2="15.8" y2="5.4" />
                <line x1="12" y1="12" x2="18.5" y2="7.8" />
                <line x1="12" y1="12" x2="19.5" y2="11.5" />
                <line x1="12" y1="12" x2="18.2" y2="15.5" />
                <line x1="12" y1="12" x2="15.2" y2="18.2" />
                <line x1="12" y1="12" x2="12" y2="19.5" />
                <line x1="12" y1="12" x2="8.5" y2="18" />
                <line x1="12" y1="12" x2="5.8" y2="15" />
                <line x1="12" y1="12" x2="5" y2="11" />
                <line x1="12" y1="12" x2="6.2" y2="7.2" />
                <line x1="12" y1="12" x2="8.8" y2="5.2" />
            </g>
        </svg>
    );
};
